import React, {useEffect, useState} from 'react';
import {
		Box,
		Button,
		Card,
		CardContent,
		CardHeader,
		Divider,
		Grid
} from '@material-ui/core';
import {useNavigate, useParams} from "react-router";
import FormLoading from "../../../components/FormLoading";
import {useCrudForm} from "../../../hooks/crud/Form";
import {useTranslation} from "react-i18next";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import ParkingZoneRepository from "../../../repositories/ParkingZoneRepository";
import ParkingZoneGroupRepository from "../../../repositories/ParkingZoneGroupRepository";
import UserRepository from "../../../repositories/UserRepository";

const Form = () => {
	const navigate = useNavigate();
	const {t} = useTranslation();

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

	const {id} = useParams();

	const repository = new UserRepository();
	const [parkingZones, setParkingZones] = useState([]);
	const [selectedParkingZones, setSelectedParkingZones] = useState([]);
	const [parkingZoneGroups, setParkingZoneGroups] = useState([]);
	const [selectedParkingZoneGroups, setSelectedParkingZoneGroups] = useState([]);

	const { form, onSubmit, isSubmitting, hasError, errorMessage } = useCrudForm(repository, {
            id: id,
            onSuccess: () => navigate("/app/users"),
            onLoad: (data) => {
                if (data) {
                    updateParkingZones(data.ParkingZones);
                    updateParkingZoneGroups(data.ParkingZoneGroups);
                }
            }
        }

        );
	const { control, register, setValue, watch, unregister } = form;

    useEffect(async () => {

        const parkingZoneRepository = new ParkingZoneRepository();
        const parkingZoneGroupRepository = new ParkingZoneGroupRepository();

        const result2 = await parkingZoneRepository.getSelector();
        setParkingZones(result2.data);

        const result3 = await parkingZoneGroupRepository.getSelector();
        setParkingZoneGroups(result3.data);

    }, [id]);

    useEffect(async () => {

        register('ParkingZones', { });
        register('ParkingZoneGroups', { });

        return () => {
            unregister('ParkingZones');
            unregister('ParkingZoneGroups');
        }
    }, []);

    const parkingZoneSelectHandler = ({target}) => {
        updateParkingZones(target.value);
    }

    const parkingZoneGroupSelectHandler = ({target}) => {
        updateParkingZoneGroups(target.value);
    }

    const updateParkingZones = (value) => {
        setSelectedParkingZones(value);
        setValue('ParkingZones', value);
    }

    const updateParkingZoneGroups = (value) => {
        setSelectedParkingZoneGroups(value);
        setValue('ParkingZoneGroups', value);
    }

    return (
			<form onSubmit={onSubmit}
			>
                 <Grid item xs={12} lg={8}>
                     {isSubmitting && <FormLoading />}
                     <Box mt={3}>
                         <Card>
                             <CardHeader title={t('Parking zones')} />
                             <Divider />
                             <CardContent>
                                <Select
                                      multiple
                                      fullWidth
                                      displayEmpty
                                      value={selectedParkingZones}
                                      input={<Input />}
                                      renderValue={(selected) => {
                                        return parkingZones.filter(x => selected.includes(x.Id)).map(x => x.Name).join(', ');
                                      }}
                                      MenuProps={MenuProps}
                                      onChange={parkingZoneSelectHandler}
                                    >
                                      {parkingZones.map((item) => (
                                        <MenuItem key={item.Id} value={item.Id}>
                                            <Checkbox checked={selectedParkingZones.filter(x => x == item.Id).length > 0} />
                                            <ListItemText primary={item.Name} />
                                        </MenuItem>
                                      ))}
                                    </Select>

                             </CardContent>
                         </Card>
                     </Box>`
                     <Box mt={3}>
                         <Card>
                             <CardHeader title={t('Parking zone groups')} />
                             <Divider />
                             <CardContent>
                                <Select
                                      multiple
                                      fullWidth
                                      displayEmpty
                                      value={selectedParkingZoneGroups}
                                      input={<Input />}
                                      renderValue={(selected) => {
                                        return parkingZoneGroups.filter(x => selected.includes(x.Id)).map(x => x.Name).join(', ');
                                      }}
                                      MenuProps={MenuProps}
                                      onChange={parkingZoneGroupSelectHandler}
                                    >
                                      {parkingZoneGroups.map((item) => (
                                        <MenuItem key={item.Id} value={item.Id}>
                                            <Checkbox checked={selectedParkingZoneGroups.filter(x => x == item.Id).length > 0} />
                                            <ListItemText primary={item.Name} />
                                        </MenuItem>
                                      ))}
                                    </Select>

                             </CardContent>
                         </Card>
                     </Box>`
                 </Grid>
                 <Box mt={2}>

                     <Button
                        color="secondary"
                        variant="contained"
                        type="submit"
                        name="submit"
                        disabled={isSubmitting}
                    >
                        {t('Save')}
                    </Button>
                 </Box>
            </form>
	);
};

export default Form;